import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-model/views/advanced-filters/date-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const CreationDateFilter: AdvancedTableFilter = {
  type: AdvancedFilterType.DATE,
  Icon: CalendarIcon,
  data: {
    name: "createdAt",
    type: AdvancedFilterType.DATE,
    value: null,
    operator: DateFilterOperator.AFTER,
  },
  displayName: "Shipment created",
};
